<section class="relative min-h-screen overflow-hidden bg-[#030f1d]">
  <div class="pointer-events-none absolute inset-0 bg-[rgba(3,15,29,0.55)] backdrop-blur-[2px]">
    <div
      class="absolute -left-24 -top-32 h-[26rem] w-[26rem] rounded-full bg-[rgba(50,97,153,0.35)] blur-[80px]"
    ></div>
    <div
      class="absolute -bottom-28 -right-28 h-[22rem] w-[22rem] rounded-full bg-[rgba(21,64,110,0.3)] blur-[80px]"
    ></div>
  </div>

  <main class="relative z-10 grid min-h-screen place-items-center p-6">
    <div
      class="w-full max-w-[32rem] rounded-2xl border border-[#3f5168] bg-gradient-to-b from-[#212c3a] to-[#1a2330] p-6 shadow-[0_30px_60px_rgba(0,0,0,0.35)] sm:p-9"
    >
      <header class="mb-6 flex flex-col items-center gap-3 text-center">
        <div
          class="grid h-14 w-14 place-items-center rounded-xl border border-[#3f5168] bg-[rgba(158,176,197,0.1)] text-[#c8d5e6]"
          aria-hidden="true"
        >
          <span class="text-2xl">🛡️</span>
        </div>
        <h1 class="m-0 text-[1.8rem] leading-tight text-[#eaf1fa]">Security Verification</h1>
        <p class="m-0 max-w-[26rem] text-sm text-[#9cb0c6]">
          @if (status?.maskedEmail) {
            Enter the 6-digit code sent to {{ status?.maskedEmail }}.
          } @else {
            Enter your 6-digit verification code to continue.
          }
        </p>
      </header>

      @if (verifyState === 'loading') {
        <div class="py-8 text-center text-sm text-[#9cb0c6]">Loading verification challenge...</div>
      } @else {
        <div class="flex flex-col gap-5">
          @if (isLocked) {
            <app-otp-lockout-panel
              [lockSeconds]="lockSeconds"
              (backToLogin)="onBackToLogin()"
            ></app-otp-lockout-panel>
          } @else {
            <app-otp-code-input
              [disabled]="verifyState === 'submitting'"
              [invalid]="verifyState === 'error'"
              (valueChange)="onOtpChange($event)"
              (submit)="onSubmit()"
            ></app-otp-code-input>

            @if (errorMessage) {
              <p
                class="m-0 rounded-[0.6rem] border border-[rgba(255,125,125,0.4)] bg-[rgba(255,125,125,0.08)] px-4 py-3 text-[0.86rem] text-[#ff9d9d]"
                role="alert"
              >
                {{ errorMessage }}
              </p>
            }

            <div class="flex items-center justify-between text-xs text-[#95a8be]">
              <span>
                Remaining attempts:
                <strong class="text-[#d4e0ef]">
                  {{ status?.remainingAttempts ?? 0 }}/{{ status?.maxAttempts ?? 0 }}
                </strong>
              </span>
              <span>
                Expires in:
                <strong class="tabular-nums text-[#d4e0ef]">{{ otpExpiresSeconds }}s</strong>
              </span>
            </div>

            <button
              type="button"
              (click)="onSubmit()"
              [disabled]="!canVerify"
              class="flex items-center justify-center gap-2 rounded-[0.7rem] bg-[#d5dce5] px-4 py-3 text-lg font-bold text-[#131c27] transition hover:-translate-y-px disabled:cursor-not-allowed disabled:opacity-70"
            >
              <span>{{ verifyState === 'submitting' ? 'Verifying...' : 'Verify & Enter' }}</span>
              <span aria-hidden="true">→</span>
            </button>

            <div class="flex items-center justify-between gap-3 text-xs">
              <button
                type="button"
                (click)="onResend()"
                [disabled]="!canResend"
                class="rounded-md border border-[#3f5168] px-3 py-2 font-semibold text-[#c7d5e4] transition hover:bg-[rgba(199,213,228,0.08)] disabled:cursor-not-allowed disabled:opacity-60"
              >
                {{ resendSeconds > 0 ? 'Resend in ' + resendSeconds + 's' : 'Resend Code' }}
              </button>

              <button
                type="button"
                (click)="onBackToLogin()"
                class="text-[#95a8be] underline-offset-2 transition hover:text-[#d4e0ef] hover:underline"
              >
                Back to Login
              </button>
            </div>
          }
        </div>
      }
    </div>
  </main>
</section>
